import { Injectable } from "@angular/core";
import { Subject, takeUntil } from "rxjs";
import { Select } from "src/app/shared/models/select";
import { ApiCallService } from "./api-call.service";
import { Constanst } from "../constants/constans.component";
import { HelperClassService } from "./clase-utilidades.services";

@Injectable({
    providedIn: 'root'
})
export class LoadListServices {
    private route: string;
    private method: string;
    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(
        private apiCallService: ApiCallService,
        private helperClassService: HelperClassService,
    ) { }

    public getAllCompanyBudget(): Select[] {
        let listCompany: Select[] = [];
        this.route = '/getAllCompanyBudget';
        this.method = 'GET';
        let data = {};

        this.apiCallService.call$(data, this.route, this.method, true, '', true)
            .pipe(takeUntil(this.destroy$)).subscribe(response => {
                if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
                    for (let i = 0; i < response.data.length; i++) {
                        let company: Select = { id: '', value: '' };
                        company.id = response.data[i].idCompany;
                        company.value = response.data[i].companyName;
                        listCompany.push(company);
                    }
                    this.apiCallService.hideSpinner();
                } else {
                    this.apiCallService.hideSpinner();
                    this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GET_COMPANY_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
                }
            });

        return listCompany;
    }

    public getWorksTitlesBudget(): Select[] {
        let listWorksTitles: Select[] = [];
        let opSelect: Select = { id: '', value: '' };
        opSelect.id = 'obra';
        opSelect.value = 'Obra';
        listWorksTitles.push(opSelect);
        let opSelect1: Select = { id: '', value: '' };
        opSelect1.id = 'servicio';
        opSelect1.value = 'Servicio';
        listWorksTitles.push(opSelect1);
        let opSelect2: Select = { id: '', value: '' };
        opSelect2.id = 'mantenimiento';
        opSelect2.value = 'Mantenimiento';
        listWorksTitles.push(opSelect2);
        let opSelect3: Select = { id: '', value: '' };
        opSelect3.id = 'especial';
        opSelect3.value = 'Presupuesto Especial';
        listWorksTitles.push(opSelect3);

        return listWorksTitles;
    }

    public getPriceCaptureBudget(): Select[] {
        let listPriceCaptur: Select[] = [];
        let opSelect: Select = { id: '', value: '' };
        opSelect.id = 'pBolivares';
        opSelect.value = 'Precio en Bolivares';
        listPriceCaptur.push(opSelect);
        return listPriceCaptur;
    }

    public getIvaOptionsBudget(): Select[] {
        let listIvaOptions: Select[] = [];
        let opSelect: Select = { id: '', value: '' };
        opSelect.id = '1';
        opSelect.value = 'Aplicar al Presupuesto';
        listIvaOptions.push(opSelect);
        let opSelect1: Select = { id: '', value: '' };
        opSelect1.id = '2';
        opSelect1.value = 'Aplicar por Partida';
        listIvaOptions.push(opSelect1);
        let opSelect2: Select = { id: '', value: '' };
        opSelect2.id = '3';
        opSelect2.value = 'No aplicar';
        listIvaOptions.push(opSelect2);
        return listIvaOptions;
    }

    public getReplacePricesBudget(): Select[] {
        let listReplacePrices: Select[] = [];
        let opSelect: Select = { id: '', value: '' };
        opSelect.id = '1';
        opSelect.value = 'Respetar Precios del Presupuesto';
        listReplacePrices.push(opSelect);
        return listReplacePrices;
    }
}
